import { combineReducers, } from 'redux';
import login from './Login';
import navigation from './Navigation';
import Global from './Global';
import Interface from './Interface';

export default combineReducers({
    loginResource: login,
    navigationInfo: navigation,
    globalResource: Global,
    interface : Interface
});
